import { addShapeToCanvas } from '../../lib/bezieLib/UI/UIEvents';
<template>
  <div class="shapes-side-menu">
    <!--
    <at-input v-model="searchTerm" placeholder="What would you like to find?" size="large" icon="search"></at-input>
    <div class="vspace"></div>
    
    <div>
      <at-button class="pitem left right is-shape-btn darkColor whiteBorder" type="primary" 
        icon="icon-circle" @click="addCircle">Circle</at-button>
      
      <at-button class="pitem left right is-shape-btn darkColor whiteBorder" type="primary" 
        icon="icon-square" @click="addRect">Rectangle</at-button>
      
      <at-button class="pitem left right is-shape-btn darkColor whiteBorder" type="primary" 
        icon="icon-navigation" @click="addRect">Vector</at-button>
    </div>
    -->
    <div class="left-align">
      
      <div class="left heading">Tools</div>
      <div class="is-shape-btn" @click="startVector">
        <!--<img src="https://www.svgrepo.com/show/17506/pen-tool.svg" intrinsicsize="512 x 512" width="50" height="50" srcset="https://www.svgrepo.com/show/17506/pen-tool.svg 4x" alt="Pen Tool SVG Vector" title="Pen Tool SVG Vector">
        -->
        <!--
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
        width="50" height="50" viewBox="0 0 29 32" style="margin:15px; " role="img">
          <path fill="#526780" d="M26.667 9.867l-0.96 0.96c-2.080-1.813-4.747-2.827-7.52-2.827-1.867 0-3.733 0.48-5.333 1.333l4.053-4.053c0.32 0.213 0.693 0.32 1.067 0.32 0.533 0 1.067-0.213 1.493-0.64 0.853-0.853 0.853-2.187 0-3.040-0.427-0.427-0.96-0.64-1.493-0.64s-1.067 0.213-1.493 0.64c-0.693 0.747-0.8 1.813-0.32 2.613l-5.12 5.12-0.96-0.96-2.613 2.613 0.96 0.96-5.227 5.227c-0.32-0.213-0.693-0.32-1.067-0.32-0.533 0-1.067 0.213-1.493 0.64-0.853 0.853-0.853 2.187 0 3.040 0.427 0.373 0.96 0.587 1.493 0.587s1.067-0.213 1.493-0.64c0.693-0.693 0.8-1.76 0.32-2.613l4.053-4.053c-2.133 4.107-1.653 9.227 1.493 12.853l-0.96 1.013 2.667 2.613 2.613-2.613-2.613-2.613-0.907 0.907c-3.093-3.627-3.253-8.853-0.64-12.693l0.427 0.427 2.667-2.613-0.48-0.427c1.707-1.227 3.787-1.867 5.92-1.867 2.507 0 4.853 0.907 6.773 2.507l-0.96 0.907 2.667 2.613 2.613-2.613-2.613-2.667zM12.32 28l-1.12 1.12-1.12-1.12 1.12-1.12 1.12 1.12zM17.227 2.72c0.213-0.213 0.48-0.32 0.747-0.32s0.533 0.107 0.747 0.32c0.427 0.427 0.427 1.067 0 1.493-0.213 0.213-0.48 0.32-0.747 0.32s-0.533-0.107-0.747-0.32c-0.427-0.373-0.427-1.067 0-1.493zM2.88 20.053c-0.213 0.213-0.48 0.32-0.747 0.32s-0.533-0.107-0.747-0.32c-0.213-0.16-0.32-0.427-0.32-0.747 0-0.267 0.107-0.533 0.32-0.747s0.48-0.32 0.747-0.32c0.267 0 0.533 0.107 0.747 0.32 0.427 0.427 0.427 1.12 0 1.493zM10.027 12.533l-1.12-1.12 1.12-1.12 1.12 1.12-1.12 1.12zM26.667 13.653l-1.12-1.12 1.12-1.12 1.12 1.12-1.12 1.12z"></path>
          </svg>-->
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50" height="50"
	 viewBox="0 0 325 325" style="enable-background:new 0 0 325 325;margin:15px" xml:space="preserve">  
          <path d="M294.165,179.832L167.599,2.818C166.538,1.128,164.663,0,162.521,0c-0.001,0-0.001,0-0.002,0
	c-0.232,0-0.46,0.017-0.686,0.042c-0.076,0.009-0.15,0.022-0.226,0.034c-0.139,0.021-0.276,0.045-0.412,0.075
	c-0.099,0.022-0.196,0.048-0.294,0.075c-0.105,0.029-0.208,0.06-0.31,0.096c-0.114,0.038-0.227,0.078-0.338,0.123
	c-0.069,0.028-0.136,0.06-0.204,0.09c-0.957,0.43-1.804,1.1-2.432,1.976L30.831,179.83c-1.028,1.439-1.365,3.26-0.929,4.974
	c0.437,1.714,1.61,3.149,3.202,3.92c0.156,0.076,15.811,7.766,31.189,24.292c19.01,20.429,29.274,44.705,30.568,72.232H77.327
	c-3.313,0-6,2.687-6,6V319c0,3.314,2.687,6,6,6h170.342c3.314,0,6-2.686,6-6v-27.752c0-3.313-2.686-6-6-6h-17.532
	c1.295-27.527,11.559-51.804,30.567-72.231c15.378-16.526,31.031-24.216,31.179-24.287c1.598-0.768,2.773-2.201,3.213-3.918
	C295.536,183.096,295.195,181.273,294.165,179.832z M141.882,183.328c0.003-10.869,9.254-19.714,20.621-19.717
	c5.548,0,10.751,2.075,14.652,5.843c3.844,3.714,5.96,8.637,5.959,13.862c-0.002,10.867-9.252,19.71-20.621,19.713l-0.004,6l0.001-6
	C151.127,203.028,141.882,194.189,141.882,183.328z M241.669,313H83.327v-15.752h158.342V313z M252.261,204.476
	c-14.867,15.86-32.45,42.5-34.137,80.772l-111.25-0.002c-1.687-38.271-19.271-64.91-34.139-80.771
	c-10.871-11.598-21.711-19.126-28.248-23.111L156.514,24.688l-0.033,127.477c-15.114,2.758-26.595,15.679-26.599,31.162
	c0,17.479,14.628,31.701,32.607,31.703c0,0,0.007,0,0.008,0c17.982-0.005,32.615-14.23,32.617-31.71
	c0.002-8.511-3.415-16.5-9.622-22.496c-4.713-4.552-10.609-7.53-17.012-8.677l0.033-127.417l111.995,156.635
	C273.972,185.35,263.133,192.878,252.261,204.476z"/>
        </svg>
      </div>
      
      <div class="left heading">Shapes</div>
      <div class="is-shape-btn is-inline" @click="addCircle">
        <div class="is-circle"></div>
      </div>
      <div class="is-shape-btn is-inline" @click="addRect">
        <div class="is-rect"></div>
      </div>
      <!--<div class="is-shape-btn is-inline" @click="addRect">
        <div class="is-triangle"></div>
      </div>
      <div class="is-shape-btn is-inline" @click="addRect">
        <div class="is-polygon"></div>
      </div>-->

      <div class="vspace"></div>
      <div class="vspace-2"></div> 


      
    </div>
  </div>
</template>

<script>
import { ShapeType } from '../../lib/bezieLib/Objects/Shapes/BShape'
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { Circle } from '../../lib/bezieLib/CanvasGui/Circle';


export default {
  name: 'ShapesSideMenu',
  data: function(){
    return {
      searchTerm : '',
    }
  },
  methods : {
    addCircle(){
      console.log("adding circle");
      UIEvents.addShapeToCanvas(ShapeType.CIRCLE);
    },
    addRect(){
      UIEvents.addShapeToCanvas(ShapeType.RECTANGLE);
    },
    startVector(){
      UIEvents.addShapeToCanvas(ShapeType.VECTOR);
    }
  },
  created: function(){

  }
}
</script>

<style scoped>
.is-shape-btn{
  width: 80px;
  height: 80px;
  background-color: whitesmoke;
  margin:10px;
}

.is-shape-btn:hover{
  background-color: #e5e5e6;
  cursor: pointer;
}

.is-inline{
  display: inline-block;
}
.is-circle{
  width: 40px;
  height: 40px;
  background: #555;
  border-radius: 50%;
  margin: 25% auto;
}

.is-rect{
  width: 40px;
  height: 40px;
  background: #555;
  margin: 25% auto;
}
.whiteBorder{
  border: 1px solid white;
}

.is-triangle {
  width: 0px;
  height: 0px;
  margin: 20px 0px 0px 20px;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  border-bottom: 60px solid #555;
}
  
.is-polygon {
  position: relative;
  width: 54px;
  box-sizing: content-box;
  border-width: 50px 18px 0;
  border-style: solid;
  border-color: #555 transparent;
}
.is-polygon:before {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  top: -85px;
  left: -18px;
  border-width: 0 45px 35px;
  border-style: solid;
  border-color: transparent transparent #555;
}
  
</style>